export const pushDataLayerAddToCartEvent = (itemsData) => {
  // Sometimes only a single item (i.e. single object, instead of an array) is passed
  const _items = Array.isArray(itemsData) ? itemsData : [itemsData]
  const items = _items.map(item => {
    return {
      ...item,
      // Strip special characters out of item name, like is done in data-layer-theme.liquid
      item_name: item.item_name
        ? item.item_name.replace(/\'|\"|\,|\\/g, '')
        : `N/A: ${item.item_id}`
    }
  })

  if (items.length == 0) return

  const cartValue = items
    .map(item => item.price)
    .reduce((total, current) => total + current)

  window.dataLayer = window.dataLayer || [] // Init data layer if doesn't already exist
  
  // Send dataLayer add to cart event
  window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object
  window.dataLayer.push({
    event: 'rb_add_to_cart',
    ecommerce: {
      currency: 'USD',
      value: cartValue,
      items: items,
    }
  })
}